import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=4317ecf6"
var script = {}
import style0 from "./TermOfService.vue?vue&type=style&index=0&id=4317ecf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports